import { Flex, Text, Tooltip } from '@chakra-ui/react';
import { OutlineCard } from '@morressier/alembic';
import { IUserProfileAuditAccountDetails } from '@publishing-engine/domain/models';
//import DuplicateAccountDetailsModal from './DuplicateAccountDetailsModal';

type AccountType = 'primary' | 'deactivated';

interface DuplicateAccountsProps {
  deactivatedAccounts: IUserProfileAuditAccountDetails[] | undefined;
  primaryAccount: IUserProfileAuditAccountDetails | undefined;
}

// interface SelectedAccount {
//   account: IUserProfileAuditAccountDetails;
//   accountType: AccountType;
// }

const ACCOUNT_LABEL: Record<AccountType, string> = {
  primary: 'Primary Account',
  deactivated: 'Deactivated Account'
};

const getFullName = (account: IUserProfileAuditAccountDetails) =>
  [account?.firstName, account?.middleName, account?.lastName]
    .filter(Boolean)
    .join(' ');

const AccountCard = ({
  account,
  accountType
}: {
  account: IUserProfileAuditAccountDetails;
  accountType: AccountType;
}) => (
  <OutlineCard padding={4} borderRadius={0} flex="1" minWidth="170px">
    <Flex direction="column" gap={2}>
      <Text textStyle="headingItem" color="neutralSecondaryContent">
        {ACCOUNT_LABEL[accountType]}
      </Text>
      <Text textStyle="headingItem" color="actionPrimaryFill">
        {getFullName(account)}
      </Text>
      <Tooltip label={account?.email} hasArrow placement="top">
        <Text textStyle="textBody" isTruncated>
          {account?.email}
        </Text>
      </Tooltip>
    </Flex>
  </OutlineCard>
);

const DuplicateAccounts = ({
  deactivatedAccounts,
  primaryAccount
}: DuplicateAccountsProps) => {
  if (!primaryAccount && !deactivatedAccounts?.length) return null;

  return (
    <>
      <Flex width="100%" wrap="wrap">
        {primaryAccount && (
          <AccountCard account={primaryAccount} accountType="primary" />
        )}
        {deactivatedAccounts?.map(account => (
          <AccountCard
            key={account?.userId}
            account={account}
            accountType="deactivated"
          />
        ))}
      </Flex>

      {/* {selectedAccount && (
        <DuplicateAccountDetailsModal
          account={selectedAccount.account}
          onClose={() => setSelectedAccount(null)}
          accountType={selectedAccount.accountType}
        />
      )} */}
    </>
  );
};

export default DuplicateAccounts;
